module.exports = __webpack_public_path__ + "media/icons/money-bfca2de5.png";